// Canvas ⇄ Shell postMessage contract — CANVAS (Nuxt) side.
//
// Single source of truth: the plugin's docs/protocol.md.
// CP-side mirror: the plugin's web/assets/pagebuilder/dist/js/pb-protocol.js — keep both in lockstep.
//
// This lives outside Nuxt's auto-import dirs (components/composables/utils) on purpose: import it
// explicitly so it reads as the shared contract it is, not ambient magic.

// Bump only on an INCOMPATIBLE change to an existing message. Receivers warn on mismatch.
export const PB_PROTOCOL_VERSION = 1;

// `source` discriminators on the wire.
export const PB_SHELL_SOURCE = 'pb-shell'; // shell → canvas
export const PB_CANVAS_SOURCE = 'pb'; // canvas → shell

// canvas → shell message types
export const ToShell = {
  READY: 'ready',
  SELECT: 'select',
  EDIT_BLOG_CTA: 'edit-blog-cta',
  DELETE_BLOG_CTA: 'delete-blog-cta',
  HOVER: 'hover',
  MOVE: 'move',
  REMOVE: 'remove',
  INLINE_EDIT: 'inline-edit',
  INLINE_EDIT_NESTED: 'inline-edit-nested',
  REFRESHED: 'refreshed',
  COMMENT_ADD: 'comment:add',
  COMMENT_REPLY: 'comment:reply',
  COMMENT_RESOLVE: 'comment:resolve',
  COMMENT_DELETE: 'comment:delete',
  COMMENT_TICKET: 'comment:ticket',
} as const;

// shell → canvas message types
export const ToCanvas = {
  SELECT: 'select',
  REFRESH: 'refresh',
  COMMENTS: 'comments',
} as const;

export type ToShellType = (typeof ToShell)[keyof typeof ToShell];
export type ToCanvasType = (typeof ToCanvas)[keyof typeof ToCanvas];
